import React, { Component } from "react";

import { Link } from "react-router-dom";
import { Menu, Dropdown, Divider } from "antd";
import "./mobilemenu.css";
const { Item } = Menu;
export class MobileMenu extends Component {
  render() {
    const menu = (
      <Menu>
        {this.props.menus.map((menu) => (
          <Item key={menu.menuId}>
            <Link
              to={menu.menuUrl || ""}
              onClick={() => {
                this.props.clearselection();
              }}
            >
              <span>{menu.menu}</span>
            </Link>
            <Divider></Divider>
          </Item>
        ))}
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <i
          className="ms-Icon ms-Icon--GlobalNavButton ms-fontSize-42 hamburger"
          aria-hidden="true"
        ></i>
      </Dropdown>
    );
  }

  _onShowMenuClicked() {
    let isvisible = this.state.isCalloutVisible;
    this.setState({
      isCalloutVisible: !isvisible,
    });
  }

  dismiss() {
    this.setState({
      isCalloutVisible: false,
    });
  }
}

